"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUtil = void 0;
const GeoJSON_1 = __importDefault(require("ol/format/GeoJSON"));
const Vector_1 = __importDefault(require("ol/layer/Vector"));
const Vector_2 = __importDefault(require("ol/source/Vector"));
const shpjs_1 = __importDefault(require("shpjs"));
/**
 * Helper class for adding layers from various file formats.
 *
 * @class
 */
class FileUtil {
    /**
     * Adds a new vector layer from a geojson file.
     * @param {File} file the file to read the geojson from
     * @param {import("ol/Map").default} map the map to add the layer to
     */
    static addGeojsonLayerFromFile(file, map) {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.addEventListener('loadend', () => {
            const content = reader.result;
            FileUtil.addGeojsonLayer(content, map);
        });
    }
    /**
     * Adds a new vector layer from a shape file (zip).
     * @param {File} file the file to read the geojson from
     * @param {import("ol/Map").default} map the map to add the layer to
     */
    static addShpLayerFromFile(file, map) {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.addEventListener('loadend', () => {
            const blob = reader.result;
            (0, shpjs_1.default)(blob).then((json) => {
                FileUtil.addGeojsonLayer(json, map);
            });
        });
    }
    /**
     * Adds a new vector layer from a geojson string.
     * @param {string|object} json the geojson string or object
     * @param {import("ol/Map").default} map the map to add the layer to
     */
    static addGeojsonLayer(json, map) {
        const format = new GeoJSON_1.default();
        const features = format.readFeatures(json);
        const layer = new Vector_1.default({
            source: new Vector_2.default({
                features: features
            })
        });
        map.addLayer(layer);
    }
}
exports.FileUtil = FileUtil;
exports.default = FileUtil;
